import _objectSpread from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _asyncToGenerator from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import Head from "@/components/Head/index.vue";
import Pagination from "@/components/Pagination/index.vue";
import useCurrentInstance from "@/hooks/useCurrentInstance";
import { defineComponent, computed, toRefs, reactive } from "vue";
import { ElMessageBox, ElMessage } from "element-plus";
import 'element-plus/es/components/message-box/style/index'
import 'element-plus/es/components/message/style/index'

import { useStore } from "vuex";
import { SuccessFilled, ArrowRight } from "@element-plus/icons";
import { useRoute, useRouter } from "vue-router";
export default defineComponent({
  name: "Detail",
  components: {
    Head: Head,
    Pagination: Pagination,
    SuccessFilled: SuccessFilled,
    ArrowRight: ArrowRight
  },
  setup: function setup() {
    var _useCurrentInstance = useCurrentInstance(),
        globalProperties = _useCurrentInstance.globalProperties;

    var router = useRouter();
    var objectId = useRoute().query.objectId;
    var userId = useStore().state.user.user.userId;
    var transformationTime = computed(function () {
      return function (time) {
        console.log(time);
        var data = new Date(time);
        var year = data.getFullYear();
        var month = data.getMonth() + 1;
        var date = data.getDate();
        var h = data.getHours();
        var m = data.getMinutes();
        return year + "/" + month + "/" + date + " " + (h < 10 ? "0".concat(h) : h) + ":" + (m < 10 ? "0".concat(m) : m);
      };
    }); // 图片路径前缀

    var baseUrl = process.env.VUE_APP_BASE_URL;
    var dataList = reactive({
      data: {},
      totalNum: 0,
      identity: 0
    }); // 获取预览图片列表

    var previewImgList = computed(function () {
      return function (imgs) {
        var imageList = [];
        var imgList = imgs.split(',');
        imgList.forEach(function (item) {
          imageList.push(baseUrl + item);
        });
        return imageList;
      };
    });
    init();

    function init() {
      getTabledata();
    } // 获取数据


    function getTabledata() {
      return _getTabledata.apply(this, arguments);
    } // 返回


    function _getTabledata() {
      _getTabledata = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["getHelpInPairsDetail"]({
                  objectId: objectId
                });

              case 2:
                res = _context.sent;

                if (res.code == 0) {
                  dataList.data = res.data;
                }

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _getTabledata.apply(this, arguments);
    }

    function back() {
      router.back();
    } // 跳转添加步骤


    function toProgress() {
      if (dataList.data.status == 2) {
        return;
      }

      router.push({
        path: "/personal/helpProgress",
        query: {
          objectId: objectId
        }
      });
    }

    function operation(_x) {
      return _operation.apply(this, arguments);
    }

    function _operation() {
      _operation = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(type) {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(!dataList.data.messages || dataList.data.messages.length == 0)) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt("return", false);

              case 2:
                ElMessageBox({
                  title: "提示",
                  message: "\u662F\u5426\u786E\u8BA4\u63D0\u4EA4\uFF1F",
                  showCancelButton: true,
                  confirmButtonText: "确定",
                  cancelButtonText: "取消"
                }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                  var res;
                  return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          _context2.next = 2;
                          return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["editState"]({
                            objectId: objectId,
                            state: type
                          });

                        case 2:
                          res = _context2.sent;

                          if (res.code == 0) {
                            ElMessage.success("提交成功");
                            getTabledata();
                          }

                        case 4:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee2);
                }))).catch(function () {// console.log("2222");
                }); // const res= await globalProperties?.$api['getHelpInPairsDetail']({
                //   objectId: objectId,
                // });
                // if(res.code==0){
                //   dataList.data=res.data
                // }

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));
      return _operation.apply(this, arguments);
    }

    return _objectSpread({
      baseUrl: baseUrl,
      userId: userId,
      transformationTime: transformationTime,
      previewImgList: previewImgList,
      operation: operation,
      toProgress: toProgress,
      back: back
    }, toRefs(dataList));
  }
});